const appConfig = {
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',
  assetsCdnUrl: process.env.NEXT_PUBLIC_ASSETS_CDN_URL,
  imagesCdnUrl: process.env.NEXT_PUBLIC_IMAGES_CDN_URL,
  combineImagesCdnUrl: process.env.NEXT_PUBLIC_COMBINE_IMAGES_CDN_URL,
  isProdEnvironment: process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod',
  isDevEnvironment: process.env.NEXT_PUBLIC_ENVIRONMENT === 'development',
  isPublicWebsite:
    process.env.NEXT_PUBLIC_IS_PRODUCTION_WEBSITE === 'true' ||
    process.env.NEXT_PUBLIC_IS_BETA_WEBSITE === 'true' ||
    process.env.NEXT_PUBLIC_IS_CRAWL_WEBSITE === 'true' ||
    process.env.NEXT_PUBLIC_IS_ALPHA_WEBSITE === 'true',
  isBetaWebsite: process.env.NEXT_PUBLIC_IS_BETA_WEBSITE === 'true',
  isAlphaWebsite: process.env.NEXT_PUBLIC_IS_ALPHA_WEBSITE === 'true',
  homApiUrl: process.env.NEXT_PUBLIC_HOM_API_URL || 'https://dev.api.houseofmath.com',
  homApiDockerServiceUrlBase: process.env.NEXT_HOM_API_DOCKER_SERVICE_URL || 'http://hom-api:8000',
  playcanvas: {
    homebase: new URL(process.env.NEXT_PUBLIC_HOMEBASE_URL ?? 'https://playcanv.as/e/p/Z3wnzb4E/'),
    mathVault: new URL(process.env.NEXT_PUBLIC_MATH_VAULT_URL ?? 'https://playcanv.as/e/p/tOEl7mmE/'),
    bootcampBoss: new URL(process.env.NEXT_PUBLIC_BOOTCAMP_BOSS_URL ?? 'https://playcanv.as/e/p/pbOcMrbO/'),
    circleCombiantions: new URL(process.env.NEXT_PUBLIC_CIRCLE_COMBINATIONS_URL ?? 'https://playcanv.as/e/p/klKzJOfD/'),
    petCam: new URL(process.env.NEXT_PUBLIC_PET_CAM_URL ?? 'https://playcanv.as/e/b/8cba02da/'),
    stacknload: new URL(process.env.NEXT_PUBLIC_STACKNLOAD_URL ?? 'https://playcanv.as/e/p/WAbS9CFq/'),
    multgame: new URL(process.env.NEXT_PUBLIC_MULTGAME_URL ?? 'https://playcanv.as/e/p/LPaB3TJw/'),
    treasureTrail: new URL(process.env.NEXT_PUBLIC_TREASURETRAIL_URL ?? 'https://playcanv.as/e/p/FCP4u7IX/'),
    windSurfer: new URL(process.env.NEXT_PUBLIC_WINDSURFER_URL ?? 'https://playcanv.as/e/p/7r0hafic/'),
    badgeShowcase: new URL(process.env.NEXT_PUBLIC_BADGE_SHOWCASE_URL ?? 'https://playcanv.as/e/p/WL1ruqQs/'),
    interactiveShapeViewer: new URL(
      process.env.NEXT_PUBLIC_INTERACTIVE_SHAPE_VIEWER_URL ?? 'https://playcanv.as/e/p/oQM8KWUB/',
    ),
  },
  stripeKey: process.env.NEXT_PUBLIC_STRIPE_KEY ?? '',
  skipTrimmingProps: ['password', 'confirmPassword', 'passwordConfirm', 'currentPassword', 'newPassword'],
  growthbook: {
    apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
    decryptionKey: process.env.NEXT_PUBLIC_GROWTHBOOK_DECRYPTION_KEY,
    enableDevMode: process.env.NEXT_PUBLIC_ENVIRONMENT !== 'prod',
    streamingHost: 'https://cdn.growthbook.io',
    subscribeToChanges: true,
  },
  oracleApiUrl: process.env.NEXT_PUBLIC_ORACLE_API_URL,
  isMobileApp: process.env.NEXT_PUBLIC_IS_MOBILE_APP === 'true',
  // US school deployment: strips commerce, marketing tracking and Tutor-on-Demand from the build.
  // Build-time only (NEXT_PUBLIC_*), so Next can dead-code-eliminate the gated branches.
  isSchoolPlatform: process.env.NEXT_PUBLIC_IS_SCHOOL_PLATFORM === 'true',
  m2mTokenSecret: process.env.M2M_TOKEN_SECRET,
  avatarDataURL: 'avatars/ReadyPlayerMe/template/avatars-template.json',
}

export default appConfig
